/* ============================================================
   KALONI — theme.js
   Carrito conectado al Ajax Cart API real de Shopify
   (/cart/add.js, /cart/change.js, /cart.js). Reemplaza el
   array local del prototipo por el objeto `cart` de Shopify.

   FASE 2 · RECOMPRA PROGRAMADA (cambios marcados con [RECOMPRA])
   · addToCart acepta un 3er parámetro opcional: sellingPlanId.
     Solo se envía `selling_plan` si existe (Compra única = igual que antes).
   · El handler de .js-add-cart-pdp lee data-selling-plan-id del botón
     (lo pone sections/main-product.liquid solo en Recompra programada).
   · renderCartDrawer muestra "Recompra programada · {frecuencia}" y el
     ahorro usando item.selling_plan_allocation (datos reales de /cart.js).
   · [DESCUENTOS] Si Shopify aplica un descuento (automático o código), la
     línea muestra su nombre y monto, y el total tachado → total final.
   ============================================================ */
(function () {
  "use strict";

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const routes = (window.theme && window.theme.routes) || {};

  /* [RECOMPRA] Textos del carrito (se pueden sobrescribir desde el layout con
     window.theme.strings = { recompra: "...", ahorras: "..." }) */
  const strings = Object.assign(
    { recompra: "Recompra programada", ahorras: "Ahorras", recompraAgregada: "Recompra agregada al carrito", descuento: "Descuento" },
    (window.theme && window.theme.strings) || {}
  );

  /* ---------------- money formatting (Shopify money_format) ---------------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || "${{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    const value = (cents / 100).toFixed(2);
    const parts = value.split(".");
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const formatted = withCommas + "." + parts[1];
    return format.replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  /* [RECOMPRA] Escapa texto que viene de Shopify antes de insertarlo como HTML */
  function esc(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function toast(msg) {
    const el = $("#toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("show");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => el.classList.remove("show"), 2200);
  }

  /* ---------------- Ajax Cart API ---------------- */
  function fetchCart() {
    return fetch(routes.cart + ".js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  }

  // [RECOMPRA] sellingPlanId es opcional. Sin él, el request es idéntico al original.
  function addToCart(variantId, qty, sellingPlanId) {
    if (!variantId) {
      toast("Este producto no tiene variante disponible");
      return Promise.reject(new Error("missing variant id"));
    }
    const payload = { id: variantId, quantity: qty || 1 };
    if (sellingPlanId) payload.selling_plan = Number(sellingPlanId); // Compra única → no se envía la clave
    return fetch(routes.cartAdd || "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    })
      .then((r) => {
        if (!r.ok) return r.json().then((err) => Promise.reject(err));
        return r.json();
      })
      .then(() => fetchCart())
      .then((cart) => {
        renderCartBadge(cart);
        renderCartDrawer(cart);
        toast(sellingPlanId ? strings.recompraAgregada : "Agregado al carrito");
        openCart();
        return cart;
      })
      .catch((err) => {
        toast((err && err.description) || "No se pudo agregar el producto");
      });
  }

  function changeLine(line, quantity) {
    // Cambiar cantidad por número de línea conserva el selling plan de esa línea.
    return fetch(routes.cartChange || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        renderCartBadge(cart);
        renderCartDrawer(cart);
        return cart;
      });
  }

  /* ---------------- render carrito ---------------- */
  function renderCartBadge(cart) {
    $$("[data-cart-count]").forEach((el) => (el.textContent = cart.item_count));
  }

  /* [RECOMPRA] Bloque de la línea con Selling Plan. Compra única → "" (sin cambios). */
  /* [DESCUENTOS] Explica por qué el total de la línea es menor que precio × cantidad.
     Lee line_level_discount_allocations de /cart.js (descuentos reales de Shopify). */
  function discountLineHtml(item) {
    const allocs = item.line_level_discount_allocations || [];
    if (!allocs.length) return "";
    return allocs.map((d) => {
      const title = (d.discount_application && d.discount_application.title) || strings.descuento;
      return `<span class="k-line-discount">${esc(title)} · −${formatMoney(d.amount)}</span>`;
    }).join("");
  }
  function lineTotalHtml(item) {
    const original = item.original_line_price != null ? item.original_line_price : item.line_price;
    const final = item.final_line_price != null ? item.final_line_price : item.line_price;
    return original > final
      ? `<span class="k-line-total"><s class="k-line-total__compare">${formatMoney(original)}</s>${formatMoney(final)}</span>`
      : `<span class="k-line-total">${formatMoney(final)}</span>`;
  }

  function sellingPlanLineHtml(item) {
    const spa = item.selling_plan_allocation;
    if (!spa || !spa.selling_plan) return "";
    const plan = spa.selling_plan;
    const freq = (plan.options && plan.options[0] && plan.options[0].value) || plan.name || "";
    // compare_at_price = precio sin el plan; price = precio del plan (ambos de Shopify).
    const unitSaving = (spa.compare_at_price || 0) - (spa.price || 0);
    const lineSaving = unitSaving * item.quantity;
    return `
      <div class="k-line-plan">
        <span class="k-line-plan__tag">
          <span class="k-line-plan__mode">${esc(strings.recompra)}</span>
          <span class="k-line-plan__sep" aria-hidden="true">·</span>
          <span class="k-line-plan__freq">${esc(freq)}</span>
        </span>
        ${lineSaving > 0
          ? `<span class="k-line-plan__saving"><s class="k-line-plan__compare">${formatMoney(spa.compare_at_price * item.quantity)}</s>${esc(strings.ahorras)} ${formatMoney(lineSaving)}</span>`
          : ""}
      </div>`;
  }

  function renderCartDrawer(cart) {
    const body = $("#cartBody");
    const foot = $("#cartFoot");
    if (!body || !foot) return;
    body.innerHTML = "";
    foot.innerHTML = "";

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `<div class="empty-cart">Tu carrito está vacío.<br><br>
        <button type="button" class="btn btn-primary" id="cartEmptyCta">Explorar catálogo</button></div>`;
      const cta = $("#cartEmptyCta");
      if (cta) cta.addEventListener("click", () => { closeCart(); window.location.href = "/collections/all"; });
      return;
    }

    const freeShippingAt = Number((document.body.dataset.freeShippingAt || 0)) * 100; // en centavos
    if (freeShippingAt > 0) {
      const remaining = Math.max(0, freeShippingAt - cart.total_price);
      const pct = Math.min(100, (cart.total_price / freeShippingAt) * 100);
      const bar = document.createElement("div");
      bar.className = "shipping-bar";
      bar.innerHTML = remaining > 0
        ? `Te faltan <b>${formatMoney(remaining)}</b> para envío gratis<div class="shipping-track"><div style="width:${pct}%"></div></div>`
        : `🎉 Tienes envío gratis<div class="shipping-track"><div style="width:100%"></div></div>`;
      body.appendChild(bar);
    }

    cart.items.forEach((item, idx) => {
      const line = idx + 1;
      const el = document.createElement("div");
      el.className = "cart-item";
      if (item.selling_plan_allocation) el.classList.add("is-recompra"); // [RECOMPRA]
      el.innerHTML = `
        <div class="thumb"><img src="${item.image || ""}" alt="${esc(item.product_title)}"></div>
        <div style="flex:1;">
          <h4 style="font-size:13.5px;">${esc(item.product_title)}</h4>
          <span style="font-size:11.5px;color:var(--muted)">${formatMoney(item.price)}</span>
          ${sellingPlanLineHtml(item)}
          ${discountLineHtml(item)}
          <div class="row">
            <div class="qty-control">
              <button type="button" data-qty-minus>−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-plus>+</button>
            </div>
            ${lineTotalHtml(item)}
          </div>
          <button type="button" class="remove-link" data-remove-line>Quitar</button>
        </div>`;
      $("[data-qty-minus]", el).addEventListener("click", () => changeLine(line, item.quantity - 1));
      $("[data-qty-plus]", el).addEventListener("click", () => changeLine(line, item.quantity + 1));
      $("[data-remove-line]", el).addEventListener("click", () => changeLine(line, 0));
      body.appendChild(el);
    });

    const subtotalRow = document.createElement("div");
    subtotalRow.className = "subtotal-row";
    subtotalRow.innerHTML = `<span>Subtotal</span><span>${formatMoney(cart.total_price)}</span>`;
    // [DESCUENTOS] Descuentos a nivel pedido (no ligados a una línea).
    const cartDiscounts = (cart.cart_level_discount_applications || []).map((d) =>
      `<div class="k-cart-discount"><span>${esc(d.title || strings.descuento)}</span><span>−${formatMoney(d.total_allocated_amount)}</span></div>`).join("");
    const goBtn = document.createElement("a");
    goBtn.href = routes.cart ? routes.cart.replace(".js", "") : "/checkout";
    goBtn.className = "btn btn-primary btn-block";
    goBtn.textContent = "Ir a pagar";
    goBtn.setAttribute("href", "/checkout");
    if (cartDiscounts) foot.insertAdjacentHTML("afterbegin", cartDiscounts);
    foot.append(subtotalRow, goBtn);
  }

  /* ---------------- drawer open/close ---------------- */
  function openCart() {
    fetchCart().then((cart) => { renderCartBadge(cart); renderCartDrawer(cart); });
    $("#overlay").classList.add("show");
    $("#cartDrawer").classList.add("show");
  }
  function closeCart() {
    $("#overlay").classList.remove("show");
    $("#cartDrawer").classList.remove("show");
  }
  function closeAllOverlays() {
    closeCart();
    toggleMobileMenu(false);
  }
  function toggleMobileMenu(show) {
    const el = $("#mobileMenu");
    if (el) el.classList.toggle("show", show);
  }

  /* ---------------- PLP: buscador cliente sobre productos ya renderizados ---------------- */
  function applySearch(query) {
    const q = (query || "").trim().toLowerCase();
    $$("[data-family-group]").forEach((group) => {
      let visible = 0;
      $$(".product-card", group).forEach((card) => {
        const match = !q || (card.dataset.name || "").includes(q);
        card.classList.toggle("hidden", !match);
        if (match) visible++;
      });
      group.style.display = visible === 0 && q ? "none" : "";
    });
    const countEl = $("#plpCount");
    if (countEl) {
      const visibleCards = $$(".product-card:not(.hidden)").length;
      countEl.textContent = `${visibleCards} producto${visibleCards !== 1 ? "s" : ""}`;
    }
    const emptyMsg = $("#plpEmpty");
    if (emptyMsg) emptyMsg.classList.toggle("hidden", $$(".product-card:not(.hidden)").length !== 0);
  }

  /* ---------------- acordeón PDP ---------------- */
  function toggleAccordion(item) {
    item.classList.toggle("open");
    const icon = $(".accordion-icon", item);
    if (icon) icon.textContent = item.classList.contains("open") ? "−" : "+";
  }

  /* ---------------- delegación de eventos ---------------- */
  document.addEventListener("click", (e) => {
    const addCard = e.target.closest(".js-add-cart");
    if (addCard) {
      e.preventDefault();
      addToCart(addCard.dataset.variantId, 1); // tarjetas de colección: siempre compra única
      return;
    }

    const addPdp = e.target.closest(".js-add-cart-pdp");
    if (addPdp) {
      e.preventDefault();
      const wrap = addPdp.closest("[data-pdp-form]") || document;
      const qtyEl = $(".qty-value", wrap);
      const qty = qtyEl ? Number(qtyEl.textContent) || 1 : 1;
      const variantId = addPdp.dataset.variantId || $("[data-selected-variant-id]", wrap)?.value;
      // [RECOMPRA] Solo existe si el cliente eligió Recompra programada (lo pone main-product.liquid).
      const sellingPlanId = addPdp.dataset.sellingPlanId || null;
      addToCart(variantId, qty, sellingPlanId);
      return;
    }

    const qtyMinus = e.target.closest(".js-qty-minus");
    if (qtyMinus) {
      const span = qtyMinus.parentElement.querySelector(".qty-value");
      span.textContent = Math.max(1, Number(span.textContent) - 1);
      return;
    }
    const qtyPlus = e.target.closest(".js-qty-plus");
    if (qtyPlus) {
      const span = qtyPlus.parentElement.querySelector(".qty-value");
      span.textContent = Number(span.textContent) + 1;
      return;
    }

    const accHead = e.target.closest(".accordion-head");
    if (accHead) { toggleAccordion(accHead.closest(".accordion-item")); return; }
  });

  document.addEventListener("input", (e) => {
    if (e.target && e.target.id === "plpSearch") applySearch(e.target.value);
  });

  window.Kaloni = {
    openCart, closeCart, closeAllOverlays, toggleMobileMenu,
    addToCart, changeLine, formatMoney,
  };

  document.addEventListener("DOMContentLoaded", () => {
    fetchCart().then((cart) => { renderCartBadge(cart); renderCartDrawer(cart); });
  });
})();